import {Stack} from "@mui/material";
import {AirTemperatureChart} from "./charts/AirTemperatureChart";
import {PrecipitationChart} from "./charts/PrecipitationChart";
import {FieldResult} from "../../types/domain/fieldResult";

export interface Props {
    data: FieldResult[];
}

export const FieldWeatherInsightsView: React.FC<Props> = ({data}) => {
    return (
        <Stack direction="column" gap="1.25rem">
            <PrecipitationChart data={data} />
            <AirTemperatureChart data={data} />
        </Stack>
    );
};
